<template>
  <div class="roomManagement">
    <el-card>
      <el-form :inline="true" :model="filter" label-position="right" size="small">
        <el-form-item v-if="$myStore.state.user.userIdentity === 0" label="代理商名称：">
          <el-input v-model.trim="filter.agentName" placeholder="请输入代理商名称" />
        </el-form-item>
        <el-form-item v-if="$myStore.state.user.userIdentity !== 2" label="分销商名称：">
          <el-input v-model.trim="filter.distributName" placeholder="请输入分销商名称" />
        </el-form-item>
        <el-form-item label="学员姓名：">
          <el-input v-model.trim="filter.contractSignName" placeholder="请输入学员姓名" />
        </el-form-item>
        <el-form-item label="学员手机号：">
          <el-input v-model.trim="filter.phone" placeholder="请输入学员手机号" />
        </el-form-item>
        <el-form-item label="考试时间：" prop="date1">
          <my-datePicker :scopeDate="testTime" @receiveMyDate="receiveTestTime" />
        </el-form-item>
        <el-form-item label="考场名称：">
          <el-input v-model.trim="filter.testPlanName" placeholder="请输入考场名称" />
        </el-form-item>
        <el-form-item label="考试状态：">
          <el-select v-model="filter.testStatus" style="width:100%" placeholder="请选择">
            <el-option label="待考试" :value="1" />
            <el-option label="成绩待发布" :value="2" />
            <el-option label="已完成" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码：">
          <el-input v-model.trim="filter.contractSignIdCard" placeholder="请输入证件号码" />
        </el-form-item>
        <el-form-item label="预约时间：" prop="date1">
          <my-datePicker :scopeDate="subscribeTime" @receiveMyDate="receiveSubscribeTime" />
        </el-form-item>
        <el-form-item label="班级名称：">
          <el-input v-model.trim="filter.skuName" placeholder="请输入班级名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
          <el-button type="primary" @click="exportList">导出当前数据</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table :data="list" border>
        <el-table-column v-if="$myStore.state.user.userIdentity === 0" align="center" label="代理商名称" prop="agentName" width="200"></el-table-column>
        <el-table-column v-if="$myStore.state.user.userIdentity !== 2" align="center" label="分销商名称" prop="distributName" width="200"></el-table-column>
        <el-table-column align="center" label="学员姓名" prop="contractSignName" width="120"></el-table-column>
        <el-table-column align="center" label="学员手机号" prop="phone" width="140"></el-table-column>
        <el-table-column align="center" label="证件类型" prop="contractSignType" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.contractSignType === '1'">身份证</span>
            <span v-else-if="row.contractSignType === '2'">护照</span>
            <span v-else-if="row.contractSignType === '3'">军官证</span>
            <span v-else-if="row.contractSignType === '4'">港澳台通行证</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="证件号码" prop="contractSignIdCard" width="150"></el-table-column>
        <el-table-column align="center" label="考场名称" prop="testPlanName" width="200"></el-table-column>
        <el-table-column align="center" label="班级名称" prop="skuName" width="200"></el-table-column>
        <el-table-column align="center" label="预约时间" prop="subscribeTime" width="160"></el-table-column>
        <el-table-column align="center" label="考试时间" prop="testTime" width="160"></el-table-column>
        <el-table-column align="center" label="考试状态" prop="testStatus" width="130">
          <template slot-scope="{ row }">
            <span v-if="row.testStatus === 1">待考试</span>
            <span v-else-if="row.testStatus === 2">成绩待发布</span>
            <span v-else-if="row.testStatus === 3">已完成</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作技能成绩" prop="operation" width="130"></el-table-column>
        <el-table-column align="center" label="理论知识成绩" prop="theory" width="130"></el-table-column>
        <el-table-column align="center" label="综合评定成绩" prop="evaluationAll" width="130"></el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
  </div>
</template>

<script>
import myDatePicker from "@/components/myDatePicker.vue";
import { getListUserTestPlanSubscribe } from '@/api/product/testPlanItem.js'
import { downloadData } from '@/api/common'

export default {
  name: 'RoomManagement',

  components: { myDatePicker },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        agentName: '',
        distributName: '',
        contractSignName: '',
        phone: '',
        testTimeStart: '',
        testTimeEnd: '',
        testPlanName: '',
        testStatus: '',
        contractSignIdCard: '',
        subscribeTimeStart: '',
        subscribeTimeEnd: '',
        skuName: ''
      },
      testTime: [],
      subscribeTime: [],
      list: [],
      total: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    resetFilter() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.testTime = []
      this.subscribeTime = []
      this.getList()
    },
    exportList() {
      const params = { ...this.filter }
      delete params.page
      delete params.limit
      downloadData('/product/adm/userTestPlanSubscribe/export', params)
    },
    // 列表
    async getList() {
      const res = await getListUserTestPlanSubscribe(this.filter)
      if (res.code !== 0) return this.$message.error(res.message)
      this.list = res.data.records
      this.total = +res.data.total
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    receiveTestTime (payload) {
      this.testTime = payload
      this.filter.testTimeStart = payload[0] + " 00:00:00";
      this.filter.testTimeEnd = payload[1] + " 23:59:59";
    },
    receiveSubscribeTime (payload) {
      this.subscribeTime = payload
      this.filter.subscribeTimeStart = payload[0] + " 00:00:00";
      this.filter.subscribeTimeEnd = payload[1] + " 23:59:59";
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
